<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
defineProps(['about'])
const loadMoreText = ref('false')

const loadMore = () => {
    return loadMoreText.value = !loadMoreText.value
}
</script>
<template>
    <div v-if="about?.status">
        <section class="text-gray-600 body-font md:flex hidden">
            <div class="container 2xl:px-24 xl:px-0 pt-12 mx-auto">
                <div class="flex flex-wrap xl:pt-12 lg:pt-8 pt-0">
                    <div class="lg:w-1/2 md:w/2 md:mx-auto pt-4 xl:pl-12 wow animate__animated animate__fadeInLeft">
                        <div
                            class="2xl:w-[540px] 2xl:h-[590px] xl:w-[500px] xl:h-[550px] lg:w-[460px] lg:h-[505px] w-full h-full">
                            <VLazyImage :src="about?.image" :alt="about?.heading" class="h-full w-full object-cover object-center inline-block" />
                        </div>
                    </div>
                    <div class="lg:w-1/2 lg:mt-16 mt-4 wow animate__animated animate__fadeInRight">
                        <h1 class="text-black font-medium title-font xl:text-5xl lg:text-4xl text-2xl xl:mb-8 lg:mb-4">
                            {{ locale === 'BN' ? about?.bn_heading : about?.heading }}</h1>
                        <div class="leading-relaxed text-gray-900 xl:text-[18px] lg:text-[16px] text-[16px] text-justify"
                            v-html="locale === 'BN' ? about?.bn_content : about?.content"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="text-gray-600 body-font md:hidden flex">
            <div class="container 2xl:px-24 xl:px-0 pt-12 mx-auto">
                <div class="flex flex-wrap xl:pt-12 lg:pt-8 pt-0">
                    <div class="lg:w-1/2 md:w/2 md:mx-auto pt-4 xl:pl-12 wow animate__animated animate__fadeInLeft">
                        <div
                            class="2xl:w-[540px] 2xl:h-[590px] xl:w-[500px] xl:h-[550px] lg:w-[460px] lg:h-[505px] w-full h-full">
                            <VLazyImage :src="about?.image" :alt="about?.heading" class="h-full w-full object-cover object-center inline-block" />
                        </div>
                    </div>
                    <div class="lg:w-1/2 lg:mt-16 mt-4 wow animate__animated animate__fadeInRight">
                        <h2 class="text-black font-medium title-font xl:text-5xl lg:text-4xl text-2xl xl:mb-8 lg:mb-4">
                            {{ locale === 'BN' ? about?.bn_heading : about?.heading }}</h2>
                        <h3 class="text-black font-semibold title-font xl:text-xl lg:text-lg tracking-wide xl:my-6 my-4">{{
                                locale === 'BN' ? about?.bn_why_us : about?.why_us }}</h3>

                        <div v-show="loadMoreText"
                            class="leading-relaxed text-gray-900 xl:text-[18px] lg:text-[16px] text-[16px] text-justify"
                            v-html="locale === 'BN' ? about?.bn_content.slice(0, 250) : about?.content.slice(0, 250)">
                        </div>

                        <div v-show="!loadMoreText"
                            class="leading-relaxed text-gray-900 xl:text-[18px] lg:text-[16px] text-[16px] text-justify"
                            v-html="locale === 'BN' ? about?.bn_content : about?.content"></div>

                        <span @click="loadMore"
                            class="sm:text-base text-sm text-[#3dcae0] font-bold font-roboto cursor-pointer"> {{
                                loadMoreText ? $t('partner.read_more') :
                            $t('partner.read_less') }}
                            <i class="fa-solid fa-angles-right mt-1"></i></span>
                    </div>
                </div>
            </div>
        </section>
    </div>


</template>
<style scoped></style>
